import { render, staticRenderFns } from "./ForgotPassPage.vue?vue&type=template&id=273e24a7&"
import script from "./ForgotPassPage.vue?vue&type=script&lang=js&"
export * from "./ForgotPassPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ccsbetaccscom/web/live/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('273e24a7')) {
      api.createRecord('273e24a7', component.options)
    } else {
      api.reload('273e24a7', component.options)
    }
    module.hot.accept("./ForgotPassPage.vue?vue&type=template&id=273e24a7&", function () {
      api.rerender('273e24a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ForgotPassPage.vue"
export default component.exports